import { useEffect, useRef } from "react";
import { useUser } from "@clerk/clerk-react";
import { useLocation } from "react-router-dom";
import { getCheckoutPurchase } from "./api";
import { trackPurchase } from "./gtag";
import { createPendingCheckoutTracker } from "./pending-checkout-conversion";

/** Mount above Routes so receipt navigation cannot cancel payment verification. */
export function useCheckoutConversions() {
  const { user } = useUser();
  const userId = user?.id;
  const location = useLocation();
  const tracker = useRef<ReturnType<typeof createPendingCheckoutTracker> | null>(null);

  useEffect(() => {
    if (!userId) return;
    const current = createPendingCheckoutTracker({
      storage: () => sessionStorage,
      storageKey: `gads_pending_checkouts:${userId}`,
      verify: getCheckoutPurchase,
      report: trackPurchase,
    });
    tracker.current = current;
    current.start();
    return () => {
      current.stop();
      tracker.current = null;
    };
  }, [userId]);

  useEffect(() => {
    if (location.pathname !== "/billing/success") return;
    const checkoutId = new URLSearchParams(location.search).get("checkout_id");
    if (checkoutId) tracker.current?.enqueue(checkoutId);
  }, [userId, location.pathname, location.search]);
}
